


























// @ is an alias to /src
import {Vue, Component} from "vue-property-decorator";
import VueApexCharts from 'vue-apexcharts';
import axios from 'axios';

type StatsResponse = {
    stats: Array<Stat>
}
type Stat = {
    date: string,
    count: number,
    new: number,
    unique: number
}

@Component({
    components: {
        'v-chart': VueApexCharts
    }
})
export default class Events extends Vue {
    private name: String = ''
    private chartOptions: any = {
        chart: {
            id: 'vuechart-example'
        },
        xaxis: {
            type: "datetime",
        }
    }
    series: any = []

    private callEvents: any = {
        headers: [
            {
                text:"Created",
                value:"created_at"
            },
            {
                text: "ID",
                value: "id"
            },
            {
                text: "Calls Total",
                value: "calls"
            },
            {
                text: "Calls Today",
                value: "calls"
            },
            {
                text: "Active",
                value: "active"
            }
        ],
        data: [],
        loading: true,
    }

    mounted() {
        axios
            .get<StatsResponse>('/api/v1/stats')
            .then(response => {
                let counts: any = [];
                let news: any = [];
                let uniques: any = [];
                console.log(response.data)
                // let d = new Date(response.data.stats[0].date);
                response.data.stats.forEach(function (stat: Stat) {
                    counts.push([
                        (new Date(stat.date)).getTime(),
                        stat.count
                    ])
                    news.push([
                        (new Date(stat.date)).getTime(),
                        stat.new
                    ])
                    uniques.push([
                        (new Date(stat.date)).getTime(),
                        stat.unique
                    ])
                })
                this.series = [{
                    name: "calls",
                    data: counts,
                }, {
                    name: "new users",
                    data: news,
                }, {
                    name: "unique users",
                    data: uniques,
                }]
                let date = new Date(response.data.stats[0].date)
                console.log(date.getTime())
            })
        axios
            .get('/api/v1/events')
            .then(response => {
                let events:any = []
                response.data.events.forEach(function (el:any) {
                    events.push({
                        id: el.ID,
                        active: el.Active
                    })
                })
                this.callEvents.data = events
                this.callEvents.loading=false
            })
    }
}
